import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import RoutesApp from "./routes";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RoutesApp />
  </React.StrictMode>
);

